module.exports = __webpack_public_path__ + "static/revtel-logo-04-d6c672e7116d29c2460b3afad189f76a.png";